const envConfig = {
  test: {
    tenantId: 'bca04bdb-cd7b-4c3c-8744-59d2115cc3a7',
    clientId: 'e0ca0e83-f083-4878-a2a0-38fba021eac1',
  },
  production: {
    tenantId: 'bca04bdb-cd7b-4c3c-8744-59d2115cc3a7',
    clientId: '2763ba21-58d2-4d14-a657-5b5faaeca2f9',
  }
}

const envName =
  process.env.DEPLOY_ENV === "test" ||
  process.env.REACT_APP_DEPLOY_ENV === "test" ||
  process.env.NODE_ENV === "development"? "test" : "production";

module.exports = envConfig[envName];
